import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="service";

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}
export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}

export function selectByDealId(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectByDealId/${parameter}`,
    method: 'get',
  })
}


export default {
  insert,
  selectByDealId,
  update,
}